import { Component, Input } from '@angular/core';
import { Store } from 'src/app/core/stores.service';
import { TranslateService } from '@ngx-translate/core';
import {
  MAGENTO_PRODUCT_PREVIEW_POSITION_LABELS,
  PRESTASHOP_PRODUCT_PREVIEW_POSITION_LABELS,
  WOOCOMMERCE_PRODUCT_PREVIEW_POSITION_LABELS,
  MAGENTO_CART_PREVIEW_LABELS,
  PRESTASHOP_CART_PREVIEW_LABELS,
  WOOCOMMERCE_CART_PREVIEW_LABELS,
} from 'src/app/shared/constants/operationals';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-store-details-general-plugin',
  templateUrl: './store-details-general-plugin.component.html',
  styleUrls: ['./store-details-general-plugin.component.scss'],
})
export class StoreDetailsGeneralPluginComponent {
  @Input() store?: Store;
  all_product_labels = {
    ...MAGENTO_PRODUCT_PREVIEW_POSITION_LABELS,
    ...PRESTASHOP_PRODUCT_PREVIEW_POSITION_LABELS,
    ...WOOCOMMERCE_PRODUCT_PREVIEW_POSITION_LABELS,
  };

  all_cart_labels = {
    ...MAGENTO_CART_PREVIEW_LABELS,
    ...PRESTASHOP_CART_PREVIEW_LABELS,
    ...WOOCOMMERCE_CART_PREVIEW_LABELS,
  };

  constructor(private translate: TranslateService, private utils_service: UtilsService) {}

  getProductLabel(key: string): string {
    let product_label = '-';

    if (key) {
      product_label = this.translate.instant(this.all_product_labels[key]);
    }

    if (product_label.length > 40) {
      return product_label.slice(0, 37) + '...';
    }
    return product_label;
  }

  getCartLabel(key: string): string {
    let cart_label = '-';

    if (key) {
      cart_label = this.translate.instant(this.all_cart_labels[key]);
    }

    if (cart_label.length > 40) {
      return cart_label.slice(0, 37) + '...';
    }
    return cart_label;
  }

  getCompanySettingsBackgroundClass(settings: boolean): { [key: string]: boolean } {
    return this.utils_service.getCompanySettingsBackgroundClass(settings);
  }
}
